module.exports = __webpack_public_path__ + "static/media/visa.1a1088d5.svg";